import { render, staticRenderFns } from "./AccountSidebarGroup.vue?vue&type=template&id=b2f406e0&scoped=true&"
import script from "./AccountSidebarGroup.vue?vue&type=script&lang=js&"
export * from "./AccountSidebarGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f406e0",
  null
  
)

export default component.exports